import { useState } from 'react';
import { Form } from 'react-final-form';
import { map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, MenuItem, Popover } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import TextField from 'common/forms/TextField';
import SelectField from 'common/forms/SelectField';
import usStateAbbreviation from 'common/constants/usStateAbbreviation';
import { updateBatchShipmentFilter } from 'store/thunks/batchShipmentThunk';
import { formatZipCode } from 'common/utils';
import { validateMinLength, validateZipCode } from 'common/forms/formValidations';

const BatchShipmentFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const { filter } = useSelector(({ batchShipment }) => batchShipment);
  const popoverId = anchorEl ? 'BatchShipmentFilterButton-Popover' : undefined;
  const loading = useSelector(({ batchShipment }) => batchShipment.loading);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);

    dispatch(updateBatchShipmentFilter({ filter: formData }));
  };

  return (
    <>
      <Button
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Order Id'
                      name='orderId'
                      id='BatchShipmentFilterButton-orderId-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Address Line 1'
                      name='line1'
                      id='BatchShipmentFilterButton-line1-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Address Line 2'
                      name='line2'
                      id='BatchShipmentFilterButton-line2-input'
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='City'
                      name='city'
                      id='BatchShipmentFilterButton-city-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField
                      id='BatchShipmentFilterButton-state-dropdown'
                      label='State'
                      name='state'
                    >
                      <MenuItem value={undefined}> None </MenuItem>
                      {map(usStateAbbreviation, ({ name, abbreviation }) => (
                        <MenuItem value={abbreviation} key={abbreviation}>
                          {name}
                        </MenuItem>
                      ))}
                    </SelectField>
                  </Grid>

                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      id='BatchShipmentFilterButton-zip-input'
                      label='Zip'
                      name='zip'
                      type='zip'
                      maxLength={10}
                      format={formatZipCode}
                      validations={[validateZipCode()]}
                    />
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <LoadingButton
                      loading={loading}
                      type='submit'
                      variant='contained'
                      disabled={invalid}
                    >
                      Apply
                    </LoadingButton>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default BatchShipmentFilterButton;
